import one from "../Images/Companies/one.png";
import two from "../Images/Companies/two.png";
import three from "../Images/Companies/three.png";
import four from "../Images/Companies/four.png";
import five from "../Images/Companies/five.png";
import six from "../Images/Companies/six.png";
import seven from "../Images/Companies/seven.png";
import eight from "../Images/Companies/eight.png";
// import nine from "../Images/Companies/nine.png";
// import ten from "../Images/Companies/ten.png";

import objC from "../Images/TechStacks/objective-c.svg";
import msql from "../Images/TechStacks/ms-sql.svg";
import postgres from "../Images/TechStacks/postgre.svg";
import sass from "../Images/TechStacks/sass.svg";
import spring from "../Images/TechStacks/spring.svg";
import nodejs from "../Images/TechStacks/node-js.svg";
import swift from "../Images/TechStacks/swift.svg";
import jquery from "../Images/TechStacks/jquery.svg";
import java from "../Images/TechStacks/java.svg";
import nginx from "../Images/TechStacks/nginx.svg";
import kotlin from "../Images/TechStacks/kotlin.svg";
import ms_azure from "../Images/TechStacks/ms-azure.svg";
import angular from "../Images/TechStacks/angular.svg";
import xamarin from "../Images/TechStacks/xamarin.svg";
import bootstrap from "../Images/TechStacks/bootstrap.svg";
import c from "../Images/TechStacks/c.svg";
import html5 from "../Images/TechStacks/html5.svg";
import ionic from "../Images/TechStacks/ionic.svg";
import jasmine from "../Images/TechStacks/jasmine.svg";

export const partners = [
  { src: one, alt: "one" },
  { src: two, alt: "two" },
  { src: three, alt: "three" },
  { src: four, alt: "four" },
  { src: five, alt: "five" },
  { src: six, alt: "six" },
  { src: seven, alt: "seven" },
  { src: eight, alt: "eight" },
  // { src: nine, alt: "nine" },
  // { src: ten, alt: "ten" },
];

export const tech_stack_v1 = [
  { src: objC, alt: "objC" },
  { src: msql, alt: "msql" },
  { src: postgres, alt: "postgres" },
  { src: sass, alt: "sass" },
  { src: nodejs, alt: "nodejs" },
  { src: swift, alt: "swift" },
  { src: spring, alt: "spring" },
  { src: kotlin, alt: "kotlin" },
  { src: jquery, alt: "jquery" },
  { src: java, alt: "java" },
  { src: angular, alt: "angular" },
  { src: xamarin, alt: "xamarin" },
  { src: c, alt: "c" },
  { src: html5, alt: "html5" },
  { src: bootstrap, alt: "bootstrap" },
  { src: ionic, alt: "ionic" },
  { src: jasmine, alt: "jasmine" },
  { src: ms_azure, alt: "ms_azure" },
  { src: nginx, alt: "nginx" },
];
